import { useCallback, useMemo, useState } from "react";

import { CircleLoadingScreen } from "@/components/ui/loading/circle-screen";

import { ShowLoadingScreenToUserContext, type LoadingContextType } from "./_context";

export const ShowLoadingScreenToUserProvider = ({ children }: { children: React.ReactNode }) => {
	const [isLoading, setIsLoading] = useState(false);

	const showLoadingScreenCallback = useCallback(() => {
		setIsLoading(true);
	}, []);

	const hideLoadingScreenCallback = useCallback(() => {
		setIsLoading(false);
	}, []);

	const memoizedValue = useMemo<LoadingContextType>(
		() => ({
			showLoadingScreenCallback,
			hideLoadingScreenCallback,
		}),
		[showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return (
		<ShowLoadingScreenToUserContext.Provider value={memoizedValue}>
			{isLoading && <CircleLoadingScreen />}
			{children}
		</ShowLoadingScreenToUserContext.Provider>
	);
};
